import * as React from 'react';

export type OverlayContextType = {
    /**
     * Whether the overlay can be closed by the user.
     */
    isClosable: boolean;

    /**
     * Close the overlay and wait until the closing animation is finished.
     */
    closeAndWaitForAnimation: () => Promise<void>;

    /**
     * The ID of the overlay element.
     */
    id: string;

    /**
     * The ref of the overlay element.
     */
    ref: React.MutableRefObject<HTMLDivElement | null>;

    /**
     * True if the overlay is in pending state.
     * It means that the overlay can't be closed because it is in the middle of an action.
     */
    isPending: boolean;

    /**
     * Set the pending state of the overlay.
     */
    setIsPending: (isPending: boolean) => void;
};

export const OverlayContext = React.createContext<OverlayContextType | null>(null);
